module.exports = __webpack_public_path__ + "static/media/spinner.eb181f7f.gif";